export function PaymentSucceeded() {
  return (
    <div>
      <h1>Payment Succeeded</h1>
    </div>
  );
}